<template>
  <div>
    <b-card 
      title="Magnitude Abbreviations"
      footer-tag="footer"
      class="abbreviations-b-card">
      <b-card-body>
        <b-table class="magnitude-table" :fields="abbreviationFields" :items="abbreviationDetails">
          <template #cell(magnitude)="data">
            <span v-html="data.value"/>
          </template>
          <template #cell(decimalValue)="data">
            {{Number(data.value).toLocaleString('en-US')}}
          </template>
        </b-table>
      </b-card-body>
      <template #footer>
        For more information see <a href='https://en.wikipedia.org/wiki/Binary_prefix'>https://en.wikipedia.org/wiki/Binary_prefix</a>
      </template>
    </b-card>
    <b-card 
      title="Try it yourself"
      class="abbreviations-b-card, larger-text">
      <b-card-body>
        <table>
          <tr>
            <td>2 ^</td>
            <td class="abbreviations-b-card-td"><b-form-input class="abbreviations-b-form-input" v-model="exponentValue" :state="exponentValid" placeholder="Enter an exponent"/></td>
            <td v-if="exponentValid"> = </td>
            <td v-show="exponentValid" class="abbreviations-b-card-td"><span>2<sup>({{this.constantMultiplier}} + {{this.abbrevableExponent}})</sup></span></td>
            <td v-if="exponentValid"> = </td>
            <td v-show="exponentValid" class="abbreviations-b-card-td"><span id="constant-mult">2<sup>{{this.constantMultiplier}}</sup></span> &times; <span id="abbrevable">2<sup>{{this.abbrevableExponent}}</sup></span></td>
            <td v-if="exponentValid"> = </td>
            <td v-show="exponentValid" class="abbreviations-b-card-td"><span id="first-part">{{2 ** this.constantMultiplier}}</span> <span id="second-part">{{this.abbreviation}}</span></td>
            <td v-if="exponentValid"> = </td>
            <td class="abbreviations-b-card-td">{{actualValue}}</td>
          </tr>
        </table>
      </b-card-body>
    </b-card>
    <b-tooltip target="constant-mult" triggers="hover">
      {{2 ** this.constantMultiplier}}
    </b-tooltip>
    <b-tooltip target="abbrevable" triggers="hover">
      {{this.abbreviation}}
    </b-tooltip>
    <b-tooltip target="first-part" triggers="hover">
      2<sup>{{this.constantMultiplier}}</sup>
    </b-tooltip>
    <b-tooltip target="second-part" triggers="hover">
      2<sup>{{this.abbrevableExponent}}</sup>
    </b-tooltip>
  </div>
</template>

<script>
import {NumberFormats} from '@/util/constants'

export default {
  name: 'abbreviations',
  data () {
    return {
      exponentValue: '',
      abbreviationFields: [
        {
          key: 'abbreviation'
        },
        {
          key: 'name'
        },
        {
          key: 'magnitude'
        },
        {
          key: 'decimalValue',
          tdClass: 'magnitude-cardinality'
        }
      ],
      abbreviationDetails: [
        {abbreviation: 'K', name: 'Kilo or Kibi', magnitude: '2<sup>10</sup>', decimalValue: '1024'},
        {abbreviation: 'M', name: 'Mega or Mebi', magnitude: '2<sup>20</sup>', decimalValue: '1048576'},
        {abbreviation: 'G', name: 'Giga or Gibi', magnitude: '2<sup>30</sup>', decimalValue: '1073741824'},
        {abbreviation: 'T', name: 'Tera or Tebi', magnitude: '2<sup>40</sup>', decimalValue: '1099511627776'},
        {abbreviation: 'P', name: 'Peta or Pebi', magnitude: '2<sup>50</sup>', decimalValue: '1125899906842624'}
      ]
    }
  },
  computed: {
    exponentValid: function () {
      return this.exponentValue.length < 1 ? null : NumberFormats.EXPONENT_RE.test(this.exponentValue)
    },
    exponentIntValue: function () {
      return this.exponentValid ? parseInt(this.exponentValue) : Number.NaN
    },
    splitValue: function () {
      var leftOver = this.exponentIntValue - this.abbrevableExponent
      return this.exponentValid ? '2<sup>' + leftOver.toString() + '</sup> &times 2<sup>' + this.abbrevableExponent.toString() + '</sup>' : ''
    },
    abbreviatedValue: function () {
      var leftOver = this.exponentIntValue - this.abbrevableExponent
      var abbreviation = this.abbreviation
      return this.exponentValid ? (2 ** leftOver).toString() + ' ' + abbreviation : ''
    },
    constantMultiplier: function () {
      return this.exponentValid ? this.exponentIntValue - this.abbrevableExponent : ''
    },
    actualValue: function () {
      return this.exponentValid ? Number(2 ** (parseInt(this.exponentValue))).toLocaleString() : ''
    },
    abbreviation: function () {
      var abbrevable = this.abbrevableExponent
      switch (abbrevable) {
        case 50: return 'P'
        case 40: return 'T'
        case 30: return 'G'
        case 20: return 'M'
        case 10: return 'K'
        default: return ''
      }
    },
    abbrevableExponent: function () {
      if (!this.exponentValid) {
        return ''
      }

      var exponent = parseInt(this.exponentValue)
      if (exponent >= 50) {
        return 50
      } else if (exponent >= 40) {
        return 40
      } else if (exponent >= 30) {
        return 30
      } else if (exponent >= 20) {
        return 20
      } else if (exponent >= 10) {
        return 10
      }

      return 0
    }
  }
}
</script>

<style scoped>
.magnitude-table {
  width: 32%;
}

.magnitude-cardinality {
  text-align: right;
  padding-right: 4.0rem;
}

.magnitude-table, .magnitude-table-td, .magnitude-table-th {
  border: 1px dotted gray;
}

.abbreviations-b-card {
  margin-bottom: 1em;
}

.abbreviations-b-card-td {
  padding-left: 8px;
  padding-right: 8px;
}

.larger-text {
  font-size: x-large;
}

.abbreviations-b-form-input {
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/abbreviations.vue